module.exports = __webpack_public_path__ + "img/Tutorial_QuantitativeDeskriptorStates.c1cc4a4f.jpg";